/**
 * @module meta.actions
 *
 * Non-specific actions that affect the app at a higher level (meta).
 */
import { createAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

const reset = createAction<RootState>('meta/reset');

export const metaActions = {
  reset,
};
